const fonts = {
  body: 'ProximaNova, Helvetica Neue, Helvetica, Segoe UI, Arial, system-ui, -apple-system, sans-serif',
  heading:
    'ProximaNova, Helvetica Neue, Helvetica, Segoe UI, Arial, system-ui, -apple-system, sans-serif'
};

export default fonts;
